export default "__VITE_ASSET__Ag89VKLZ__"